/**
 * Created by glenn on 3/27/2017.
 */
import * as redux from 'redux';



export const routes = [] as Array<string[]>;
export const dataTypes = [] as Array<string[]>;
export const years = [['2015', '2015'], ['2016', '2016']] as Array<string[]>;
export const timePeriods = [] as Array<string[]>;

export const displayMethodsObj = {};

export const displayMethods = [
    ['Total Vehicle Count (number)', 'ct'],
    ['Total Vehicle Percentage (%)', 'pt'],
    ['Observation Percentage (%)', 'op'],
    ['Travel Time Availability (%)', 'av'],
    ['Average Speed (mph)', 'sp'],
    ['Average Travel Time (minutes)', 'tt']
] as Array<string[]>;

for (let s of displayMethods){
    displayMethodsObj[s[1]] = s[0]
}

export const lookupRoutes = {} as {[s: string]: string};
export const lookupDataTypes = {} as {[s: string]: string};
export const lookupTimePeriods = {} as {[s: string]: string};
export const lookupDisplayMethods = [['Observation Counts', 'ct'], ['Observation Percentages', 'pt']] as {} as {[s: string]: string};


for (let r of ['US 12/18', 'US 14 M', 'County M', 'US 14 J', 'WIS 73', 'US 151', 'I-39/90', 'US 12']) {
    routes.push([r, r]);
    lookupRoutes[r] = r;
}

const _dataTypesDisp = ['TomTom CTT', 'Bluetooth', 'NPMRDS', 'VSPOC', 'ATR'];
const _dataTypesVal = ['ctt', 'blu', 'npm', 'vsp', 'atr'];

for (let i = 0; i < _dataTypesVal.length; i++) {
    dataTypes.push([_dataTypesDisp[i], _dataTypesVal[i]]);
    lookupDataTypes[_dataTypesVal[i]] = _dataTypesDisp[i]
}

const _timePeriodsDisp = ['AM Rush', 'AM Peak', 'PM Rush', 'PM Peak', 'Weekday Daytime', 'Weekend Daytime', 'Nighttime'];
const _timePeriodsVal = ['amr', 'amp', 'pmr', 'pmp', 'wdd', 'wed', 'nht'];

for (let i = 0; i < _timePeriodsVal.length; i++) {
    timePeriods.push([_timePeriodsDisp[i], _timePeriodsVal[i]]);
    lookupTimePeriods[_timePeriodsVal[i]] = _timePeriodsDisp[i]
}

for (let d of displayMethods){
    lookupDisplayMethods[d[1]] = d[0];
}

export const ACTION_CHANGE_DATA_TYPE = 'Data Type';
export const ACTION_CHANGE_TIME_PERIOD = 'Time Period';
export const ACTION_CHANGE_DISPLAY_METHOD = 'Display Method';
export const ACTION_SET_DATA = 'set stats';
export const ACTION_CHANGE_YEAR = 'Year';


interface iSction {
    type: string;
    val: string;
}



let dataType = (state = dataTypes[0][1], action: iSction) => {
    if (action.type == ACTION_CHANGE_DATA_TYPE) {
        return action.val;
    }
    return state;
};

let year = (state=2015, action: iSction) => {
    if (action.type == ACTION_CHANGE_YEAR){
        return parseInt(action.val);
    } else {
        return state;
    }
};

let timePeriod = (state = timePeriods[0][1], action: iSction) => {
    if (action.type == ACTION_CHANGE_TIME_PERIOD) {
        return action.val;
    }
    return state;
};

let displayMethod = (state = displayMethods[0][1], action: iSction) => {
    if (action.type == ACTION_CHANGE_DISPLAY_METHOD) {
        return action.val;
    }
    return state;
};

let data = (state = {data: null, stats: null}, action: {type: string, data: Object}) => {
    if (action.type == ACTION_SET_DATA) {
        return action.data;
        // let features = action.data['features'];
//
//         let props = features[0]['properties'];
//
//         let skipThese = ['RouteName', 'ID', 'Year', 'RouteNum', 'Direction'] as string[];
//         let keys = [];
//
//         for (let p of keyValPairs(props)){
//             if (skipThese.indexOf(p.key) > -1){
//                 continue;
//             }
//             keys.push(p.key);
//         }
//
//         let valListDict = {} as {[k: string]: number[]};
//
//         for (let f of features){
//             for (let k of keys){
//                 if(!valListDict[k]){
//                     valListDict[k] = [];
//                 }
//                 if (f.properties[k] >= 0){
//                     valListDict[k].push(f.properties[k]);
//                 }
//             }
//         }
//
//         let minMaxDict = {} as {[c: string]: {min: number, max: number}};
//
//         for (let x of keyValPairs(valListDict)){
//
//             let vals = x.value  as number[];
// //             console.log(x.key);
// // console.log(vals);
//             vals.sort(function(a,b){return a - b});
//             // console.log(vals);
//
//
//             if (vals.length > 0){
//                 minMaxDict[x.key] = {min: vals[0], max: vals[vals.length - 1]};
//             } else {
//                 minMaxDict[x.key] = {min: null, max: null};
//             }
//
//             // console.log( minMaxDict[x.key]);
//         }
//
//         // console.log(minMaxDict);
//         return minMaxDict;
    } else {
        return state;
    }

};

export interface iDataInner3 {
    av?: number
    ct: number
    op?: number;
    pt: number;
    sp?: number;
    tt?: number
}


export interface iDataInner2 {
    amp: iDataInner3;
    amr: iDataInner3;
    nht: iDataInner3;
    pmp: iDataInner3;
    pmr: iDataInner3;
    wdd: iDataInner3;
    wed: iDataInner3;
}

export interface iDataInner {
    atr: iDataInner2;
    blu: iDataInner2;
    ctt: iDataInner2;
    npm: iDataInner2;
    vsp: iDataInner2;
}

export interface iStatsInner4 {
    median: number;
    mean:  number;
    max:  number;
    min:  number;
}


export interface iStatsInner3 {
    ct: iStatsInner4;
    pt: iStatsInner4;
}

export interface iStatsInner2 {
    amp: iStatsInner3;
    amr: iStatsInner3;
    nht: iStatsInner3;
    pmp: iStatsInner3;
    pmr: iStatsInner3;
    wdd: iStatsInner3;
    wed: iStatsInner3;

}


export interface iStatsInner {
    atr: iStatsInner3;
    blu: iStatsInner3;
    ctt: iStatsInner3;
    npm: iStatsInner3;
    vsp: iStatsInner3;
}

export interface iData{
    //       road          year          direction
    data: {[s: string]: {[s: string]: {[s: string]: iDataInner}}};

    //         year
    stats: {[s: string]: iStatsInner}
}

export interface iStore{
    dataType: string;
    timePeriod: string;
    displayMethod: string;
    data: iData;
    year: number;
}


export const store = redux.createStore(
    redux.combineReducers({dataType, timePeriod, displayMethod, data, year})
);



